import VButton from '@/components/Button';
import { STOCK } from '@route-types';

export default (context, data) => {
  data.retryButtonBindings = {
    to: { name: STOCK },
    class: 'btn-default',
    label: 'common.navigationCard_STOCK_shortDescription',
  };
  data.retryButtonHook = VButton;

  const parseError = cb => {
    cb();
    context.message = null; // don't use substore message

    if (!context.args) {
      context.args = JSON.parse(sessionStorage.getItem('errorArgs'));
    } else {
      sessionStorage.setItem(
        'errorArgs',
        JSON.stringify({
          targetProductName: context.args?.targetProductName,
          excludedByProductName: context.args?.excludedByProductName,
        })
      );
    }
  };

  return {
    parseError,
  };
};
